<div id="skip_anchor" class="content wideWd">
    <div class="content_title brd edit">
        <h2>{{contentMaster.contentMasterName}} 등록 <span class="template_url">content-add</span></h2>
    </div>

    <div class="scroll-y">
        <div class="table-col">
            <dl class="table">
                <div class="tb_tr">
                    <dt>공개여부</dt>
                    <dd>
                        <div class="form_toggle">
                          <input type="checkbox" id="openYn" class="blind" [(ngModel)]="content.isOpen"/>
                          <label for="openYn"><span class="blind">공개하기</span></label>
                        </div>
                    </dd>
                </div>
                <div class="tb_tr">
                    <dt>작성자</dt>
                    <dd>{{loginedUser.userId}} ({{loginedUser.userName}})</dd>
                    <dt>연락처</dt>
                    <dd>{{loginedUser.tel | tel}}</dd>
                    <dt>이메일</dt>
                    <dd>{{loginedUser.email}}</dd>
                </div>
                <div class="tb_tr">
                    <dt>첨부파일</dt>
                    <dd>
                        <input type="file" id="attachFiles" #attachFiles (change)="onAttachFileChange(attachFiles.files, $event.target)" class="blind" />
                        <label for="attachFiles" class="badge_item badge_item-min badge_item-g1">등록하기</label>
                        <div class="attachFile" *ngFor="let item of attachFileList">
                            <span class="col-green">{{item.name}}</span>&nbsp;&nbsp;
                            <button type="button" class="badge_item badge_item-min badge_item-g1" (click)="deleteAttachFile(item)">삭제하기</button>
                        </div>
                    </dd>
                </div>
                <div class="tb_tr" *ngIf="contentCategoryList && contentCategoryList.length > 0">
                    <dt>카테고리</dt>
                    <dd>
                        <div class="select">
                            <select class="select_current" [(ngModel)]="content.contentCategoryNo">
                                <option value="0">::선택하세요::</option>
                                <option *ngFor="let item of contentCategoryList" [value]="item.contentCategoryNo">{{item.contentCategoryName}}</option>
                            </select>
                        </div>
                    </dd>
                </div>
                <div class="tb_tr">
                    <dt>제목</dt>
                    <dd>
                        <div class="form">
                            <input type="text" [(ngModel)]="content.title" placeholder="제목을 입력해 주세요.(최대 40자)" class="form_input w-full" />
                        </div>
                    </dd>
                </div>
                <div class="tb_tr">
                    <dt>내용</dt>
                    <dd>
                        <textarea [(ngModel)]="content.description"></textarea>
                    </dd>
                </div>
            </dl>
        </div>
    </div>

    <div class="table_btn">
        <button type="button" class="btn-default" (click)="windowClose()">닫기</button>
        <button type="button" class="btn-success" (click)="addContent()"><b>{{contentMaster.contentMasterName}} 등록하기</b></button><!-- 공지사항 수정하기 -->
    </div>
  </div>
